<template>
  <div class>
    <v-dialog v-model="show_terms" :max-width="800" scrollable>
      <v-card>
        <v-card-title class="secondary white--text">Terms & Conditions</v-card-title>
        <v-card-text class="py-6" style="max-height:420px">
          <vue-editor @text-change="onChangeEditor" v-model="item.settings.applicants.conditions" />
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="blue" dark @click="show_terms=false">Set</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-toolbar :style="styles" dark flat>
        <v-toolbar-title class="white--text text-center">Portal Settings</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs fixed v-model="tab" style="background: rgba(0,0,0,0.2)">
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab href="#portal-settings-appearance">Appearance</v-tab>
            <v-tab href="#portal-settings-applicants">Applicants</v-tab>
            <v-tab href="#portal-settings-viewers">Viewers</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item value="portal-settings-appearance">
          <v-container style="height:340px;overflow-y:auto">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="My Portal Name"
                  @change="onChange"
                  v-model="item.name"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9" md="6">
                <v-text-field
                  readonly
                  label="Logo"
                  hide-details
                  :placeholder="item.settings.logo.name"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn fab small color="blue" dark @click="$emit('logo-upload')">
                  <v-icon small>fa-upload</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9" md="6">
                <v-text-field
                  label="Banner color (This will apply to all sections)"
                  hide-details
                  v-model="item.settings.banner_color"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-menu
                  top
                  :close-on-content-click="false"
                  origin="center center"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="item.settings.banner_color"
                      icon
                      x-large
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-large>fas fa-square</v-icon>
                    </v-btn>
                  </template>

                  <v-color-picker
                    class="grey lighten-4"
                    hide-canvas
                    v-model="item.settings.banner_color"
                    @update:color="onBannerColor"
                    show-swatches
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col cols="9" md="6">
                <v-text-field
                  label="Button color (This will apply to all sections)"
                  hide-details
                  v-model="item.settings.button_color"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-menu
                  top
                  origin="center center"
                  :close-on-content-click="false"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      :color="item.settings.button_color"
                      fab
                      :dark="isButtonDark"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fas fa-plus</v-icon>
                    </v-btn>
                  </template>

                  <v-color-picker
                    @update:color="onButtonColor"
                    class="grey lighten-4"
                    hide-canvas
                    v-model="item.settings.button_color"
                    show-swatches
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="portal-settings-applicants">
          <v-container style="height:340px;overflow-y:auto">
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.applicants.require.phone"
                  @change="onChange"
                  color="green"
                  label="Require Phone #"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.applicants.require.all_sections"
                  @change="onChange"
                  color="green"
                  label="Require all sections"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.applicants.require.conditions"
                  @change="onTerms"
                  color="green"
                  label="Require Terms &amp; Conditions"
                  class="mt-0 pt-0"
                >
                  <template v-slot:append v-if="item.settings.applicants.require.conditions">
                    <v-btn style="margin-top:-8px" icon @click="show_terms=true">
                      <v-icon>fa-edit</v-icon>
                    </v-btn>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>

        <v-tab-item value="portal-settings-viewers">
          <v-container style="height:340px;overflow-y:auto">
            <v-row>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.name"
                  @change="onChange"
                  color="green"
                  label="Show All Names"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.email"
                  @change="onChange"
                  color="green"
                  label="Show All E-mails"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.phone"
                  @change="onChange"
                  color="green"
                  label="Show All Phone #'s"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.videos"
                  @change="onChange"
                  color="green"
                  label="Show All Videos"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.photos"
                  @change="onChange"
                  color="green"
                  label="Show All Photos"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.documents"
                  @change="onChange"
                  color="green"
                  label="Show All Documents"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.show.notes"
                  @change="onChange"
                  color="green"
                  label="Show All Notes"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  inset
                  hide-details
                  v-model="item.settings.viewers.downloads"
                  @change="onChange"
                  color="green"
                  label="Public Downloads"
                  class="mt-0 pt-0"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PortalSettings",
  props: ["value", "styles"],
  data() {
    return {
      tab: "portal-settings-appearance",
      show_terms: false
    };
  },
  computed: {
    item() {
      return this.value;
    },
    isButtonDark() {
      return (
        this.$helpers.lightOrDark(this.item.settings.button_color) === "dark"
      );
    }
  },
  methods: {
    onChangeEditor(delta, oldDelta) {
      if (oldDelta.ops.length !== 1) {
        this.onChange();
      }
    },
    onTerms(to) {
      console.log("onTerms", to);
      this.onChange();
      if (to) {
        this.show_terms = true;
      }
    },
    onChange() {
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },
    onBannerColor(to) {
      console.log("Setting banner color default");
      this.item.settings.banner_color = to.hex;
      this.item.sections.forEach(s => {
        s.banner_color = to.hex;
      });
      this.onChange();
    },
    onButtonColor(to) {
      console.log("Setting button color default");
      this.item.settings.button_color = to.hex;
      this.item.sections.forEach(s => {
        s.button_color = to.hex;
      });
      this.onChange();
    }
  }
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>